/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Rcnv_Quote_EmInputs */

const es_landing_rcnv_quote_em = /** @type {(inputs: Landing_Rcnv_Quote_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bajo demanda a precios muy accesibles.`)
};

const gl_landing_rcnv_quote_em = /** @type {(inputs: Landing_Rcnv_Quote_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`baixo demanda a prezos moi accesibles.`)
};

const en_landing_rcnv_quote_em = /** @type {(inputs: Landing_Rcnv_Quote_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`on demand at very affordable prices.`)
};

/**
* | output |
* | --- |
* | "on demand at very affordable prices." |
*
* @param {Landing_Rcnv_Quote_EmInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_rcnv_quote_em = /** @type {((inputs?: Landing_Rcnv_Quote_EmInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Rcnv_Quote_EmInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_rcnv_quote_em(inputs)
	if (locale === "en") return en_landing_rcnv_quote_em(inputs)
	return es_landing_rcnv_quote_em(inputs)
});